'use client';

import {createContext, PropsWithChildren, useMemo} from 'react';

import {CaptchaProvider} from '../types';

type CaptchaContextType = {
  /**
   * если true и в урле есть кверя autotest,
   * то вместо обычного провайдера будет просто мок который сразу даст мок-токен
   */
  allowBypassCaptcha: boolean;
  /** активный провайдер капчи (например из тоггла омикрона) */
  provider: CaptchaProvider;
  /** siteKey для яндекса */
  yandexSiteKey: string;
  /** ручка через которую можно получить токен капчи */
  vkInitEndpoint: string;
  /**
   * если передано, то капчи не рендерятся;
   *
   * можно использовать в том кейзе, когда еще ждем ответа от омикрона
   */
  disabled?: boolean;
};

export const CaptchaContext = createContext<CaptchaContextType>({
  provider: 'yandex',
  yandexSiteKey: '',
  allowBypassCaptcha: false,
  vkInitEndpoint: '/api/vk-captcha-init',
});

export const CaptchaContextProvider = ({
  provider,
  yandexSiteKey,
  allowBypassCaptcha,
  vkInitEndpoint,
  disabled,
  children,
}: PropsWithChildren<CaptchaContextType>) => {
  const contextValue = useMemo(
    () => ({
      provider,
      yandexSiteKey,
      allowBypassCaptcha,
      vkInitEndpoint,
      disabled,
    }),
    [provider, yandexSiteKey, allowBypassCaptcha, vkInitEndpoint, disabled],
  );
  return (
    <CaptchaContext.Provider value={contextValue}>
      {children}
    </CaptchaContext.Provider>
  );
};
